import React, { memo } from "react";
import styled from "styled-components";
import { negativeColor } from "../../../helpers/color";
import { transparentizedNegativeColor } from "../../../helpers/transparentize";
import { useScope } from "./state/scope";
import { useLocked } from "./state/locked";
const Root = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-luccz8-0"
})(["z-index:1;position:absolute;top:0;left:0;bottom:0;transform:translateX(-1px);background-image:repeating-linear-gradient( 45deg,transparent,transparent 6px,", " 6px,", " 8px );&::after{content:\"\";position:absolute;top:0;left:0;bottom:0;border-left:2px dashed ", ";}"], transparentizedNegativeColor, transparentizedNegativeColor, negativeColor));
const Locked = /*#__PURE__*/memo(() => {
  const scope = useScope();
  const locked = useLocked();
  if (!locked) return false;
  const displayLength = Math.min(scope.length, scope.end - locked);
  if (displayLength <= 0) return false;
  return /*#__PURE__*/React.createElement(Root, {
    style: {
      width: `${displayLength / scope.length * 100}%`,
      left: `${Math.max(0, locked - scope.start) / scope.length * 100}%`
    }
  });
});
export default Locked;
//# sourceMappingURL=Locked.js.map